export default __webpack_public_path__ + "static/media/Background 5_00033.5f8ece11.png";